import {
  State,
  TransformsPlugin,
  RenderPlugin,
  minimalLight,
  InputPlugin,
} from '@multiplekex/shallot';
import { OrbitPlugin, TextPlugin } from '@multiplekex/shallot/extras';
import {
  setupCanvas,
  setupScrollPassthrough,
  setupDemo,
} from '@blog-components/sequence';
import { SpeedupPlugin, setParams } from '../src/speedup-plugin';
import { mount } from 'svelte';
import SpeedupControls from './SpeedupControls.svelte';
import { k, targetLatencyMs, draftLatencyMs, acceptanceProb } from './speedup-store';

async function init(): Promise<void> {
  const canvas = document.getElementById('canvas') as HTMLCanvasElement;
  const controlsEl = document.getElementById('controls');
  if (!canvas) return;

  setupCanvas(canvas);
  setupScrollPassthrough(canvas);
  window.addEventListener('resize', () => setupCanvas(canvas));

  const state = await State.new()
    .withCanvas(canvas)
    .withLoading(minimalLight(canvas))
    .withPlugins(
      TransformsPlugin,
      RenderPlugin,
      InputPlugin,
      OrbitPlugin,
      TextPlugin,
      SpeedupPlugin
    )
    .withScene('../scenes/speedup.scene')
    .build();

  setupDemo(canvas, state);

  // Subscribe to stores and update plugin params
  k.subscribe(($k) => setParams({ k: $k }));
  targetLatencyMs.subscribe(($t) => setParams({ targetLatencyMs: $t }));
  draftLatencyMs.subscribe(($d) => setParams({ draftLatencyMs: $d }));
  acceptanceProb.subscribe(($a) => setParams({ acceptanceProb: $a }));

  if (controlsEl) {
    mount(SpeedupControls, { target: controlsEl });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
